import { Message, Pastille } from './ui.tsx';

interface Ligne { elementId: string; elementNom: string; codes: string[]; equivalence: string; valeurRsh: number | null; sommeDhis2: number | null; ecart: number | null; statut: 'EGAL' | 'ECART' | 'NON_COMPARABLE'; raison?: string }
export interface Comparaison {
  periode: { debut: string; fin: string; jours: string[] };
  lignes: Ligne[];
  problemes: Array<{ type: string; message: string }>;
  synthese: { egal: number; ecart: number; nonComparable: number; joursManquants: string[]; ok: boolean };
}

/** Contrôle automatique : valeur du RSH hebdomadaire ↔ somme des 7 journées DHIS2 (écart attendu : 0). */
export default function ControleRshDhis2({ c }: { c: Comparaison }) {
  const comparables = c.lignes.filter((l) => l.statut !== 'NON_COMPARABLE');
  const autres = c.lignes.filter((l) => l.statut === 'NON_COMPARABLE');
  const fr = (d: string) => `${d.slice(8)}/${d.slice(5, 7)}`;
  return (
    <div className="carte" style={{ marginTop: 12 }}>
      <h2>Contrôle : RSH = somme des 7 journées DHIS2</h2>
      <p className="aide">Période : du lundi {fr(c.periode.debut)} au dimanche {fr(c.periode.fin)} ({c.periode.jours.length} jours, lundi et dimanche inclus, aucun jour d'une autre semaine).</p>
      <Message niveau={c.synthese.ok ? 'ok' : 'bad'}>
        {c.synthese.ok ? `Tous les indicateurs comparables sont égaux (${c.synthese.egal}).` : `${c.synthese.ecart} indicateur(s) en ÉCART : ne partagez pas avant analyse.`} {c.synthese.nonComparable} non comparable(s).
      </Message>
      {c.synthese.joursManquants.length > 0 && <Message niveau="warn">Jours sans aucune consultation (aucune valeur journalière : donnée manquante, pas un zéro) : {c.synthese.joursManquants.map(fr).join(', ')}.</Message>}
      <div className="defil"><table className="saisie">
        <thead><tr><th>Indicateur DHIS2</th><th>Code(s) RSH</th><th>Valeur RSH</th><th>Σ 7 jours DHIS2</th><th>Écart</th><th>Statut</th></tr></thead>
        <tbody>{comparables.map((l) => (
          <tr key={l.elementId + l.codes.join()} style={l.statut === 'ECART' ? { background: '#fdecea' } : undefined}>
            <td>{l.elementNom.trim()}{l.equivalence === 'A_VERIFIER' && <> <Pastille niveau="info">à vérifier</Pastille></>}</td>
            <td>{l.codes.join(' + ')}</td><td style={{ textAlign: 'right' }}>{l.valeurRsh}</td><td style={{ textAlign: 'right' }}>{l.sommeDhis2}</td>
            <td style={{ textAlign: 'right' }}><b>{l.ecart}</b></td><td>{l.statut === 'EGAL' ? <Pastille niveau="ok">égal</Pastille> : <Pastille niveau="bad">écart</Pastille>}</td>
          </tr>))}</tbody>
      </table></div>
      {autres.length > 0 && (
        <details style={{ marginTop: 8 }}><summary>{autres.length} élément(s) non comparable(s) — raison</summary>
          <ul>{autres.map((l) => <li key={l.elementId + l.codes.join()}><b>{l.elementNom.trim()}</b> ({l.codes.join(' + ')}) : {l.raison}</li>)}</ul>
        </details>)}
      {c.problemes.some((p) => p.type === 'AMBIGU') && <Message niveau="warn">{c.problemes.filter((p) => p.type === 'AMBIGU').slice(0, 1).map((p) => p.message)} Corrigez la correspondance dans Référentiels → Correspondances DHIS2.</Message>}
    </div>
  );
}
